import React, { Component } from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';
import { ReactComponent as Autocomplete } from '../../icons/autocomplete.svg';
import { ReactComponent as AutocompleteCheck } from '../../icons/autocomplete-check.svg';
import { ReactComponent as Automotive } from '../../icons/automotive.svg';
import { ReactComponent as Buildings } from '../../icons/buildings.svg';
import { ReactComponent as Battery } from '../../icons/battery.svg';
import { ReactComponent as Blog } from '../../icons/blog.svg';
import { ReactComponent as Book } from '../../icons/book.svg';
import { ReactComponent as Calendar } from '../../icons/calendar.svg';
import { ReactComponent as Care } from '../../icons/care.svg';
import { ReactComponent as Cars } from '../../icons/cars.svg';
import { ReactComponent as Cb } from '../../icons/cb.svg';
import { ReactComponent as ChatLove } from '../../icons/chat-love.svg';
import { ReactComponent as ChatConversation } from '../../icons/chat-conversation.svg';
import { ReactComponent as CheckBig } from '../../icons/check-big.svg';
import { ReactComponent as CallToAction } from '../../icons/call-to-action.svg';
import { ReactComponent as CubeBig } from '../../icons/cube-big.svg';
import { ReactComponent as CustomersServices } from '../../icons/customers-services.svg';
import { ReactComponent as Customize } from '../../icons/customize.svg';
import { ReactComponent as DeliveryTime } from '../../icons/delivery-time.svg';
import { ReactComponent as DeliveryVan } from '../../icons/delivery-van.svg';
import { ReactComponent as Demo } from '../../icons/demo.svg';
import { ReactComponent as Ecommerce } from '../../icons/e-commerce.svg';
import { ReactComponent as ElectricCharge } from '../../icons/electric-charge.svg';
import { ReactComponent as Elephant } from '../../icons/elephant.svg';
import { ReactComponent as EmailContact } from '../../icons/email-contact.svg';
import { ReactComponent as Equalizer } from '../../icons/equalizer.svg';
import { ReactComponent as Escalator } from '../../icons/escalator.svg';
import { ReactComponent as Funnel } from '../../icons/funnel.svg';
import { ReactComponent as GasPump } from '../../icons/gas-pump.svg';
import { ReactComponent as Gdpr } from '../../icons/gdpr.svg';
import { ReactComponent as Github } from '../../icons/github.svg';
import { ReactComponent as Green } from '../../icons/green.svg';
import { ReactComponent as Heart } from '../../icons/heart.svg';
import { ReactComponent as HouseInsurance } from '../../icons/house-insurance.svg';
import { ReactComponent as IndoorOutdoor } from '../../icons/indoor-outdoor.svg';
import { ReactComponent as InformationRound } from '../../icons/information-round.svg';
import { ReactComponent as Institution } from '../../icons/institution.svg';
import { ReactComponent as Integrations } from '../../icons/integrations.svg';
import { ReactComponent as Itinerary } from '../../icons/itinerary.svg';
import { ReactComponent as Like } from '../../icons/like.svg';
import { ReactComponent as Logistics } from '../../icons/logistics.svg';
import { ReactComponent as Lotus } from '../../icons/lotus.svg';
import { ReactComponent as Map3d } from '../../icons/map-3d.svg';
import { ReactComponent as MapHd } from '../../icons/map-hd.svg';
import { ReactComponent as MapIndoor } from '../../icons/map-indoor.svg';
import { ReactComponent as MapLocation } from '../../icons/map-location.svg';
import { ReactComponent as MapMarkers } from '../../icons/map-markers.svg';
import { ReactComponent as Markers } from '../../icons/markers.svg';
import { ReactComponent as MarkerArrow } from '../../icons/marker-arrow.svg';
import { ReactComponent as MarkerApp } from '../../icons/marker-app.svg';
import { ReactComponent as MarkerCreditCard } from '../../icons/marker-credit-card.svg';
import { ReactComponent as MarkerCity } from '../../icons/marker-city.svg';
import { ReactComponent as MarkerGeofence } from '../../icons/marker-geofence.svg';
import { ReactComponent as MarkerHouse } from '../../icons/marker-house.svg';
import { ReactComponent as MarkerInfinite } from '../../icons/markers-infinite.svg';
import { ReactComponent as MarkerMap } from '../../icons/marker-map.svg';
import { ReactComponent as MarkerMatrix } from '../../icons/marker-matrix.svg';
import { ReactComponent as MarkerMultiple } from '../../icons/marker-multiple.svg';
import { ReactComponent as MarkerPlay } from '../../icons/marker-play.svg';
import { ReactComponent as MarkerRoad } from '../../icons/marker-road.svg';
import { ReactComponent as MarkerSearch } from '../../icons/marker-search.svg';
import { ReactComponent as MarkerShop } from '../../icons/marker-shop.svg';
import { ReactComponent as MobileRocket } from '../../icons/mobile-rocket.svg';
import { ReactComponent as Notification } from '../../icons/notification.svg';
import { ReactComponent as NotificationPosition } from '../../icons/notification-position.svg';
import { ReactComponent as OpenSource } from '../../icons/open-source.svg';
import { ReactComponent as Package } from '../../icons/package.svg';
import { ReactComponent as PackageReturn } from '../../icons/package-return.svg';
import { ReactComponent as Parking } from '../../icons/parking.svg';
import { ReactComponent as PieChart } from '../../icons/pie-chart.svg';
import { ReactComponent as PlaceReview } from '../../icons/place-review.svg';
import { ReactComponent as Plane } from '../../icons/plane.svg';
import { ReactComponent as Position } from '../../icons/position.svg';
import { ReactComponent as PuzzleStar } from '../../icons/puzzle-star.svg';
import { ReactComponent as Quote } from '../../icons/quote.svg';
import { ReactComponent as Refresh } from '../../icons/refresh.svg';
import { ReactComponent as Repair } from '../../icons/repair.svg';
import { ReactComponent as Responsive } from '../../icons/responsive.svg';
import { ReactComponent as Restaurant } from '../../icons/restaurant.svg';
import { ReactComponent as Rocket } from '../../icons/rocket.svg';
import { ReactComponent as SaveTime } from '../../icons/save-time.svg';
import { ReactComponent as SaveMoney } from '../../icons/save-money.svg';
import { ReactComponent as SearchSettings } from '../../icons/search-settings.svg';
import { ReactComponent as SearchUser } from '../../icons/search-user.svg';
import { ReactComponent as Schedule } from '../../icons/schedule.svg';
import { ReactComponent as ScooterDelivery } from '../../icons/scooter-delivery.svg';
import { ReactComponent as SecuritPositionZone } from '../../icons/security-position-zone.svg';
import { ReactComponent as Security } from '../../icons/security.svg';
import { ReactComponent as SecurityTools } from '../../icons/security-tools.svg';
import { ReactComponent as SecurityStaff } from '../../icons/security-staff.svg';
import { ReactComponent as SecurityZone } from '../../icons/security-zone.svg';
import { ReactComponent as ServiceMarker } from '../../icons/service-marker.svg';
import { ReactComponent as ShakeHand } from '../../icons/shake-hand.svg';
import { ReactComponent as Shipping } from '../../icons/shipping.svg';
import { ReactComponent as Shop } from '../../icons/shop.svg';
import { ReactComponent as Speed } from '../../icons/speed.svg';
import { ReactComponent as StarBig } from '../../icons/star-big.svg';
import { ReactComponent as StarFilledBig } from '../../icons/star-filled-big.svg';
import { ReactComponent as SupportTime } from '../../icons/support-time.svg';
import { ReactComponent as Synchronization } from '../../icons/synchronization.svg';
import { ReactComponent as Taxi } from '../../icons/taxi.svg';
import { ReactComponent as Tools } from '../../icons/tools.svg';
import { ReactComponent as Travel } from '../../icons/travel.svg';
import { ReactComponent as TshirtMarker } from '../../icons/tshirt-marker.svg';
import { ReactComponent as UserProfile } from '../../icons/user-profile.svg';
import { ReactComponent as Wheelchair } from '../../icons/wheelchair.svg';
import { ReactComponent as Wifi } from '../../icons/wifi.svg';
import { ReactComponent as World } from '../../icons/world.svg';
import { ReactComponent as WorldLocation } from '../../icons/world-location.svg';
import { ReactComponent as WorldTime } from '../../icons/world-time.svg';
import { ReactComponent as WinPrize } from '../../icons/win-prize.svg';
import { ReactComponent as Zoom } from '../../icons/zoom.svg';

import { ReactComponent as Add } from '../../icons/add.svg';
import { ReactComponent as AddCircle } from '../../icons/add-circle.svg';
import { ReactComponent as AdministrationTool } from '../../icons/administration-tool.svg';
import { ReactComponent as AdminKey } from '../../icons/admin-key.svg';
import { ReactComponent as AdminTool } from '../../icons/admin-tool.svg';
import { ReactComponent as Agenda } from '../../icons/agenda.svg';
import { ReactComponent as AlphabeticalOrder } from '../../icons/alphabetical-order.svg';
import { ReactComponent as AlphabeticalOrderReversed } from '../../icons/alphabetical-order-reversed.svg';
import { ReactComponent as ArrowBotton } from '../../icons/arrow-bottom.svg';
import { ReactComponent as ArrowLeft } from '../../icons/arrow-left.svg';
import { ReactComponent as ArrowLink } from '../../icons/arrow-link.svg';
import { ReactComponent as ArrowRight } from '../../icons/arrow-right.svg';
import { ReactComponent as ArrowTop } from '../../icons/arrow-top.svg';
import { ReactComponent as Asset } from '../../icons/asset.svg';
import { ReactComponent as BigCommerce } from '../../icons/big-commerce.svg';
import { ReactComponent as Bulb } from '../../icons/bulb.svg';
import { ReactComponent as CaretBotton } from '../../icons/caret-bottom.svg';
import { ReactComponent as CaretLeft } from '../../icons/caret-left.svg';
import { ReactComponent as CaretRight } from '../../icons/caret-right.svg';
import { ReactComponent as CaretTop } from '../../icons/caret-top.svg';
import { ReactComponent as Charts } from '../../icons/charts.svg';
import { ReactComponent as Check } from '../../icons/check.svg';
import { ReactComponent as Clock } from '../../icons/clock.svg';
import { ReactComponent as ClockReversed } from '../../icons/clock-reversed.svg';
import { ReactComponent as Close } from '../../icons/close.svg';
import { ReactComponent as Code } from '../../icons/code.svg';
import { ReactComponent as Company } from '../../icons/company.svg';
import { ReactComponent as Copy } from '../../icons/copy.svg';
import { ReactComponent as Cube } from '../../icons/cube.svg';
import { ReactComponent as Dashboard } from '../../icons/dashboard.svg';
import { ReactComponent as Delete } from '../../icons/delete.svg';
import { ReactComponent as Documentation } from '../../icons/documentation.svg';
import { ReactComponent as Dollar } from '../../icons/dollar.svg';
import { ReactComponent as Dot } from '../../icons/dot.svg';
import { ReactComponent as DotFill } from '../../icons/dot-fill.svg';
import { ReactComponent as Edit } from '../../icons/edit.svg';
import { ReactComponent as Email } from '../../icons/email.svg';
import { ReactComponent as Eye } from '../../icons/eye.svg';
import { ReactComponent as EyeCrossedOut } from '../../icons/eye-crossed-out.svg';
import { ReactComponent as Expand } from '../../icons/expand.svg';
import { ReactComponent as Export } from '../../icons/export.svg';
import { ReactComponent as Flag } from '../../icons/flag.svg';
import { ReactComponent as Forbidden } from '../../icons/forbidden.svg';
import { ReactComponent as Globe } from '../../icons/globe.svg';
import { ReactComponent as Hourglass } from '../../icons/hourglass.svg';
import { ReactComponent as Import } from '../../icons/import.svg';
import { ReactComponent as Info } from '../../icons/info.svg';
import { ReactComponent as Latitude } from '../../icons/latitude.svg';
import { ReactComponent as Load } from '../../icons/load.svg';
import { ReactComponent as Longitude } from '../../icons/longitude.svg';
import { ReactComponent as Manage } from '../../icons/manage.svg';
import { ReactComponent as Marker } from '../../icons/marker.svg';
import { ReactComponent as Members } from '../../icons/members.svg';
import { ReactComponent as Member } from '../../icons/member.svg';
import { ReactComponent as MenuSandwitch } from '../../icons/menu-sandwitch.svg';
import { ReactComponent as MenuVertical } from '../../icons/menu-vertical.svg';
import { ReactComponent as Minus } from '../../icons/minus.svg';
import { ReactComponent as Phone } from '../../icons/phone.svg';
import { ReactComponent as Play } from '../../icons/play.svg';
import { ReactComponent as ProductActivated } from '../../icons/product-activated.svg';
import { ReactComponent as ProductAdd } from '../../icons/product-add.svg';
import { ReactComponent as Products } from '../../icons/products.svg';
import { ReactComponent as Projects } from '../../icons/projects.svg';
import { ReactComponent as Question } from '../../icons/question.svg';
import { ReactComponent as Search } from '../../icons/search.svg';
import { ReactComponent as SeePage } from '../../icons/see-page.svg';
import { ReactComponent as Settings } from '../../icons/settings.svg';
import { ReactComponent as Shield } from '../../icons/shield.svg';
import { ReactComponent as Shortcut } from '../../icons/shortcut.svg';
import { ReactComponent as Star } from '../../icons/star.svg';
import { ReactComponent as StarFilled } from '../../icons/star-filled.svg';
import { ReactComponent as Support } from '../../icons/support.svg';
import { ReactComponent as Switch } from '../../icons/switch.svg';
import { ReactComponent as Team } from '../../icons/team.svg';
import { ReactComponent as Time } from '../../icons/time.svg';
import { ReactComponent as User } from '../../icons/user.svg';
import { ReactComponent as ViewCard } from '../../icons/view-card.svg';
import { ReactComponent as ViewList } from '../../icons/view-list.svg';
import { ReactComponent as Warning } from '../../icons/warning.svg';
import { ReactComponent as Woosmap } from '../../icons/woosmap.svg';
import { ReactComponent as Address } from '../../icons/address.svg';
import { ReactComponent as Distance } from '../../icons/distance.svg';
import { ReactComponent as Geolocation } from '../../icons/geolocation.svg';
import { ReactComponent as Localities } from '../../icons/localities.svg';
import { ReactComponent as Map } from '../../icons/map.svg';

import { ReactComponent as Merchant } from '../../icons/merchant.svg';
import { ReactComponent as Stores } from '../../icons/stores.svg';
import { ReactComponent as Traffic } from '../../icons/traffic.svg';
import { ReactComponent as Geofencing } from '../../icons/geofencing.svg';
import { ReactComponent as StoreLocator } from '../../icons/storelocator.svg';
import { ReactComponent as MultiSearch } from '../../icons/multisearch.svg';
import { ReactComponent as Mapping } from '../../icons/mapping.svg';
import { ReactComponent as Connectors } from '../../icons/connectors.svg';
import { ReactComponent as Showcases } from '../../icons/showcases.svg';
import { ReactComponent as Indoor } from '../../icons/indoor.svg';

import { ReactComponent as SocialFacebook } from '../../icons/social-facebook.svg';
import { ReactComponent as SocialGithub } from '../../icons/social-github.svg';
import { ReactComponent as SocialGoogle } from '../../icons/social-google.svg';
import { ReactComponent as SocialLinkedin } from '../../icons/social-linkedin.svg';
import { ReactComponent as SocialTwitter } from '../../icons/social-twitter.svg';

import { ReactComponent as Indoor3dobjectChair } from '../../icons/indoor-3dobject_chair.svg';
import { ReactComponent as Indoor3dobjectCloset } from '../../icons/indoor-3dobject_closet.svg';
import { ReactComponent as Indoor3dobjectHanger } from '../../icons/indoor-3dobject_hanger.svg';
import { ReactComponent as Indoor3dobjectRack } from '../../icons/indoor-3dobject_rack.svg';
import { ReactComponent as Indoor3dobjectSofa } from '../../icons/indoor-3dobject_sofa.svg';
import { ReactComponent as Indoor3dobjectTable } from '../../icons/indoor-3dobject_table.svg';
import { ReactComponent as IndoorAccessories } from '../../icons/indoor-accessories.svg';
import { ReactComponent as IndoorAdministration } from '../../icons/indoor-administration.svg';
import { ReactComponent as IndoorAirlineTransfers } from '../../icons/indoor-airline_transfers.svg';
import { ReactComponent as IndoorAirlinesCounter } from '../../icons/indoor-airlines_counter.svg';
import { ReactComponent as IndoorAlcohol } from '../../icons/indoor-alcohol.svg';
import { ReactComponent as IndoorAmenity } from '../../icons/indoor-amenity.svg';
import { ReactComponent as IndoorArrival } from '../../icons/indoor-arrival.svg';
import { ReactComponent as IndoorArt } from '../../icons/indoor-art.svg';
import { ReactComponent as IndoorAssemblyPoint } from '../../icons/indoor-assembly_point.svg';
import { ReactComponent as IndoorAtm } from '../../icons/indoor-atm.svg';
import { ReactComponent as IndoorBaggageBelt } from '../../icons/indoor-baggage_belt.svg';
import { ReactComponent as IndoorBaggageClaim } from '../../icons/indoor-baggage_claim.svg';
import { ReactComponent as IndoorBaggageSecureWrap } from '../../icons/indoor-baggage_secure_wrap.svg';
import { ReactComponent as IndoorBaggageService } from '../../icons/indoor-baggage_service.svg';
import { ReactComponent as IndoorBakery } from '../../icons/indoor-bakery.svg';
import { ReactComponent as IndoorBank } from '../../icons/indoor-bank.svg';
import { ReactComponent as IndoorBar } from '../../icons/indoor-bar.svg';
import { ReactComponent as IndoorBarrier } from '../../icons/indoor-barrier.svg';
import { ReactComponent as IndoorBeauty } from '../../icons/indoor-beauty.svg';
import { ReactComponent as IndoorBench } from '../../icons/indoor-bench.svg';
import { ReactComponent as IndoorBuilding } from '../../icons/indoor-building.svg';
import { ReactComponent as IndoorBureauDeChange } from '../../icons/indoor-bureau_de_change.svg';
import { ReactComponent as IndoorCafe } from '../../icons/indoor-cafe.svg';
import { ReactComponent as IndoorCarRental } from '../../icons/indoor-car_rental.svg';
import { ReactComponent as IndoorCashRegister } from '../../icons/indoor-cash_register.svg';
import { ReactComponent as IndoorCheckin } from '../../icons/indoor-checkin.svg';
import { ReactComponent as IndoorClass } from '../../icons/indoor-class.svg';
import { ReactComponent as IndoorClothes } from '../../icons/indoor-clothes.svg';
import { ReactComponent as IndoorConvinienceStore } from '../../icons/indoor-convinience_store.svg';
import { ReactComponent as IndoorCosmetics } from '../../icons/indoor-cosmetics.svg';
import { ReactComponent as IndoorDefault } from '../../icons/indoor-default.svg';
import { ReactComponent as IndoorDefibrillator } from '../../icons/indoor-defibrillator.svg';
import { ReactComponent as IndoorDepartmentStore } from '../../icons/indoor-department_store.svg';
import { ReactComponent as IndoorDeviceChargingStation } from '../../icons/indoor-device_charging_station.svg';
import { ReactComponent as IndoorDining } from '../../icons/indoor-dining.svg';
import { ReactComponent as IndoorDisability } from '../../icons/indoor-disability.svg';
import { ReactComponent as IndoorDoctors } from '../../icons/indoor-doctors.svg';
import { ReactComponent as IndoorDoor } from '../../icons/indoor-door.svg';
import { ReactComponent as IndoorDrinkingWater } from '../../icons/indoor-drinking_water.svg';
import { ReactComponent as IndoorDutyFree } from '../../icons/indoor-duty_free.svg';
import { ReactComponent as IndoorElectronics } from '../../icons/indoor-electronics.svg';
import { ReactComponent as IndoorElevator } from '../../icons/indoor-elevator.svg';
import { ReactComponent as IndoorExitEmergency } from '../../icons/indoor-exit-emergency.svg';
import { ReactComponent as IndoorEntertainment } from '../../icons/indoor-entertainment.svg';
import { ReactComponent as IndoorEntrance } from '../../icons/indoor-entrance.svg';
import { ReactComponent as IndoorConveyingForward } from '../../icons/indoor-escalator.svg';
import { ReactComponent as IndoorFashionAccessories } from '../../icons/indoor-fashion_accessories.svg';
import { ReactComponent as IndoorFastFood } from '../../icons/indoor-fast_food.svg';
import { ReactComponent as IndoorFireExtinguisher } from '../../icons/indoor-fire_extinguisher.svg';
import { ReactComponent as IndoorFlightTicket } from '../../icons/indoor-flight_ticket.svg';
import { ReactComponent as IndoorFlorist } from '../../icons/indoor-florist.svg';
import { ReactComponent as IndoorFoodCourt } from '../../icons/indoor-food_court.svg';
import { ReactComponent as IndoorGate } from '../../icons/indoor-gate.svg';
import { ReactComponent as IndoorGift } from '../../icons/indoor-gift.svg';
import { ReactComponent as IndoorInformation } from '../../icons/indoor-information.svg';
import { ReactComponent as IndoorInteriorDecoration } from '../../icons/indoor-interior_decoration.svg';
import { ReactComponent as IndoorJewelry } from '../../icons/indoor-jewelry.svg';
import { ReactComponent as IndoorKitchen } from '../../icons/indoor-kitchen.svg';
import { ReactComponent as IndoorLaboratory } from '../../icons/indoor-laboratory.svg';
import { ReactComponent as IndoorLevel } from '../../icons/indoor-level.svg';
import { ReactComponent as IndoorLounge } from '../../icons/indoor-lounge.svg';
import { ReactComponent as IndoorMeeting } from '../../icons/indoor-meeting.svg';
import { ReactComponent as IndoorNewsagent } from '../../icons/indoor-newsagent.svg';
import { ReactComponent as IndoorParking } from '../../icons/indoor-parking.svg';
import { ReactComponent as IndoorPharmacy } from '../../icons/indoor-pharmacy.svg';
import { ReactComponent as IndoorPlaceOfWorship } from '../../icons/indoor-place_of_worship.svg';
import { ReactComponent as IndoorPlane } from '../../icons/indoor-plane.svg';
import { ReactComponent as IndoorPostOffice } from '../../icons/indoor-post_office.svg';
import { ReactComponent as IndoorRails } from '../../icons/indoor-rails.svg';
import { ReactComponent as IndoorRamp } from '../../icons/indoor-ramp.svg';
import { ReactComponent as IndoorReceptionDesk } from '../../icons/indoor-reception_desk.svg';
import { ReactComponent as IndoorRestaurant } from '../../icons/indoor-restaurant.svg';
import { ReactComponent as IndoorRoom } from '../../icons/indoor-room.svg';
import { ReactComponent as IndoorSecurity } from '../../icons/indoor-security.svg';
import { ReactComponent as IndoorServer } from '../../icons/indoor-server.svg';
import { ReactComponent as IndoorShoes } from '../../icons/indoor-shoes.svg';
import { ReactComponent as IndoorShop } from '../../icons/indoor-shop.svg';
import { ReactComponent as IndoorShower } from '../../icons/indoor-shower.svg';
import { ReactComponent as IndoorSmokingArea } from '../../icons/indoor-smoking_area.svg';
import { ReactComponent as IndoorStairs } from '../../icons/indoor-stairs.svg';
import { ReactComponent as IndoorStorage } from '../../icons/indoor-storage.svg';
import { ReactComponent as IndoorSupermarket } from '../../icons/indoor-supermarket.svg';
import { ReactComponent as IndoorTaxi } from '../../icons/indoor-taxi.svg';
import { ReactComponent as IndoorTechnical } from '../../icons/indoor-technical.svg';
import { ReactComponent as IndoorTelephone } from '../../icons/indoor-telephone.svg';
import { ReactComponent as IndoorTerrace } from '../../icons/indoor-terrace.svg';
import { ReactComponent as IndoorToilets } from '../../icons/indoor-toilets.svg';
import { ReactComponent as IndoorTrain } from '../../icons/indoor-train.svg';
import { ReactComponent as IndoorTransports } from '../../icons/indoor-transports.svg';
import { ReactComponent as IndoorTravelAgency } from '../../icons/indoor-travel_agency.svg';
import { ReactComponent as IndoorUnderwear } from '../../icons/indoor-underwear.svg';
import { ReactComponent as IndoorVenue } from '../../icons/indoor-venue.svg';
import { ReactComponent as IndoorWasteBasket } from '../../icons/indoor-waste_basket.svg';
import { ReactComponent as IndoorWorkplace } from '../../icons/indoor-workplace.svg';
import { ReactComponent as MapRoute } from '../../icons/map-route.svg';
import { ReactComponent as MapWalk } from '../../icons/map-walk.svg';
import { ReactComponent as MapBike } from '../../icons/map-bike.svg';
import { ReactComponent as MapTrain } from '../../icons/map-train.svg';
import { ReactComponent as MapCar } from '../../icons/map-car.svg';
import { ReactComponent as MapSwitch } from '../../icons/map-switch.svg';
import { ReactComponent as MapItinerary } from '../../icons/map-itinerary.svg';
import { ReactComponent as MapClose } from '../../icons/map-close.svg';
import { ReactComponent as MapOrigin } from '../../icons/map-origin.svg';
import { ReactComponent as MapPin } from '../../icons/map-pin.svg';
import { ReactComponent as MapSearch } from '../../icons/map-search.svg';
import { ReactComponent as MapArrowTop } from '../../icons/map-arrow-top.svg';
import { ReactComponent as MapArrowBottom } from '../../icons/map-arrow-bottom.svg';

const WebsiteIcons = {
    autocomplete: Autocomplete,
    'autocomplete-check': AutocompleteCheck,
    automotive: Automotive,
    'arrow-link': ArrowLink,
    battery: Battery,
    blog: Blog,
    book: Book,
    buildings: Buildings,
    calendar: Calendar,
    care: Care,
    cars: Cars,
    'call-to-action': CallToAction,
    cb: Cb,
    'check-big': CheckBig,
    'chat-love': ChatLove,
    'chat-conversation': ChatConversation,
    'cube-big': CubeBig,
    'customers-services': CustomersServices,
    customize: Customize,
    'delivery-time': DeliveryTime,
    'delivery-van': DeliveryVan,
    demo: Demo,
    'e-commerce': Ecommerce,
    'electric-charge': ElectricCharge,
    elephant: Elephant,
    'email-contact': EmailContact,
    equalizer: Equalizer,
    escalator: Escalator,
    funnel: Funnel,
    'gas-pump': GasPump,
    gdpr: Gdpr,
    github: Github,
    green: Green,
    heart: Heart,
    'house-insurance': HouseInsurance,
    'indoor-outdoor': IndoorOutdoor,
    'information-round': InformationRound,
    institution: Institution,
    integrations: Integrations,
    itinerary: Itinerary,
    like: Like,
    lotus: Lotus,
    logistics: Logistics,
    'map-3d': Map3d,
    'map-hd': MapHd,
    'map-indoor': MapIndoor,
    'map-location': MapLocation,
    'map-markers': MapMarkers,
    markers: Markers,
    'marker-arrow': MarkerArrow,
    'marker-app': MarkerApp,
    'marker-credit-card': MarkerCreditCard,
    'marker-city': MarkerCity,
    'marker-geofence': MarkerGeofence,
    'markers-infinite': MarkerInfinite,
    'marker-house': MarkerHouse,
    'marker-map': MarkerMap,
    'marker-matrix': MarkerMatrix,
    'marker-multiple': MarkerMultiple,
    'marker-play': MarkerPlay,
    'marker-road': MarkerRoad,
    'marker-search': MarkerSearch,
    'marker-shop': MarkerShop,
    'mobile-rocket': MobileRocket,
    notification: Notification,
    'notification-position': NotificationPosition,
    'open-source': OpenSource,
    package: Package,
    'package-return': PackageReturn,
    parking: Parking,
    'pie-chart': PieChart,
    'place-review': PlaceReview,
    plane: Plane,
    position: Position,
    'puzzle-star': PuzzleStar,
    quote: Quote,
    refresh: Refresh,
    repair: Repair,
    responsive: Responsive,
    restaurant: Restaurant,
    rocket: Rocket,
    'save-money': SaveMoney,
    'search-settings': SearchSettings,
    'search-user': SearchUser,
    'save-time': SaveTime,
    schedule: Schedule,
    'scooter-delivery': ScooterDelivery,
    security: Security,
    'security-position-zone': SecuritPositionZone,
    'security-tools': SecurityTools,
    'security-staff': SecurityStaff,
    'security-zone': SecurityZone,
    'service-marker': ServiceMarker,
    'shake-hand': ShakeHand,
    shipping: Shipping,
    shop: Shop,
    speed: Speed,
    'star-big': StarBig,
    'star-filled-big': StarFilledBig,
    'support-time': SupportTime,
    synchronization: Synchronization,
    taxi: Taxi,
    tools: Tools,
    travel: Travel,
    'tshirt-marker': TshirtMarker,
    'user-profile': UserProfile,
    wheelchair: Wheelchair,
    wifi: Wifi,
    world: World,
    'world-location': WorldLocation,
    'world-time': WorldTime,
    'win-prize': WinPrize,
    zoom: Zoom,
};

const ConsoleIcons = {
    'add-circle': AddCircle,
    add: Add,
    'admin-key': AdminKey,
    'admin-tool': AdminTool,
    'administration-tool': AdministrationTool,
    agenda: Agenda,
    'alphabetical-order': AlphabeticalOrder,
    'alphabetical-order-reversed': AlphabeticalOrderReversed,
    'arrow-bottom': ArrowBotton,
    'arrow-left': ArrowLeft,
    'arrow-right': ArrowRight,
    'arrow-top': ArrowTop,
    asset: Asset,
    'big-commerce': BigCommerce,
    bulb: Bulb,
    'caret-bottom': CaretBotton,
    'caret-left': CaretLeft,
    'caret-right': CaretRight,
    'caret-top': CaretTop,
    charts: Charts,
    check: Check,
    clock: Clock,
    'clock-reversed': ClockReversed,
    close: Close,
    code: Code,
    company: Company,
    copy: Copy,
    cube: Cube,
    dashboard: Dashboard,
    delete: Delete,
    documentation: Documentation,
    dollar: Dollar,
    dot: Dot,
    'dot-fill': DotFill,
    edit: Edit,
    email: Email,
    expand: Expand,
    export: Export,
    'eye-crossed-out': EyeCrossedOut,
    eye: Eye,
    flag: Flag,
    forbidden: Forbidden,
    globe: Globe,
    hourglass: Hourglass,
    import: Import,
    info: Info,
    latitude: Latitude,
    load: Load,
    longitude: Longitude,
    manage: Manage,
    marker: Marker,
    member: Member,
    members: Members,
    'menu-sandwitch': MenuSandwitch,
    'menu-vertical': MenuVertical,
    minus: Minus,
    phone: Phone,
    play: Play,
    'product-activated': ProductActivated,
    'product-add': ProductAdd,
    products: Products,
    projects: Projects,
    question: Question,
    search: Search,
    'see-page': SeePage,
    settings: Settings,
    shield: Shield,
    shortcut: Shortcut,
    'social-facebook': SocialFacebook,
    'social-github': SocialGithub,
    'social-google': SocialGoogle,
    'social-linkedin': SocialLinkedin,
    'social-twitter': SocialTwitter,
    'star-filled': StarFilled,
    star: Star,
    support: Support,
    switch: Switch,
    team: Team,
    time: Time,
    user: User,
    'view-card': ViewCard,
    'view-list': ViewList,
    warning: Warning,
    woosmap: Woosmap,

    'indoor-3dobject_chair': Indoor3dobjectChair,
    'indoor-3dobject_closet': Indoor3dobjectCloset,
    'indoor-3dobject_hanger': Indoor3dobjectHanger,
    'indoor-3dobject_rack': Indoor3dobjectRack,
    'indoor-3dobject_sofa': Indoor3dobjectSofa,
    'indoor-3dobject_table': Indoor3dobjectTable,
    'indoor-accessories': IndoorAccessories,
    'indoor-administration': IndoorAdministration,
    'indoor-airline_transfers': IndoorAirlineTransfers,
    'indoor-airlines_counter': IndoorAirlinesCounter,
    'indoor-alcohol': IndoorAlcohol,
    'indoor-amenity': IndoorAmenity,
    'indoor-arrival': IndoorArrival,
    'indoor-art': IndoorArt,
    'indoor-assembly_point': IndoorAssemblyPoint,
    'indoor-atm': IndoorAtm,
    'indoor-baggage_belt': IndoorBaggageBelt,
    'indoor-baggage_claim': IndoorBaggageClaim,
    'indoor-baggage_secure_wrap': IndoorBaggageSecureWrap,
    'indoor-baggage_service': IndoorBaggageService,
    'indoor-bakery': IndoorBakery,
    'indoor-bank': IndoorBank,
    'indoor-bar': IndoorBar,
    'indoor-barrier': IndoorBarrier,
    'indoor-beauty': IndoorBeauty,
    'indoor-bench': IndoorBench,
    'indoor-building': IndoorBuilding,
    'indoor-bureau_de_change': IndoorBureauDeChange,
    'indoor-cafe': IndoorCafe,
    'indoor-car_rental': IndoorCarRental,
    'indoor-cash_register': IndoorCashRegister,
    'indoor-checkin': IndoorCheckin,
    'indoor-class': IndoorClass,
    'indoor-clothes': IndoorClothes,
    'indoor-convinience_store': IndoorConvinienceStore,
    'indoor-cosmetics': IndoorCosmetics,
    'indoor-default': IndoorDefault,
    'indoor-defibrillator': IndoorDefibrillator,
    'indoor-department_store': IndoorDepartmentStore,
    'indoor-device_charging_station': IndoorDeviceChargingStation,
    'indoor-dining': IndoorDining,
    'indoor-disability': IndoorDisability,
    'indoor-doctors': IndoorDoctors,
    'indoor-door': IndoorDoor,
    'indoor-drinking_water': IndoorDrinkingWater,
    'indoor-duty_free': IndoorDutyFree,
    'indoor-electronics': IndoorElectronics,
    'indoor-elevator': IndoorElevator,
    'indoor-exit-emergency': IndoorExitEmergency,
    'indoor-entertainment': IndoorEntertainment,
    'indoor-entrance': IndoorEntrance,
    'indoor-conveying-forward': IndoorConveyingForward,
    'indoor-fashion_accessories': IndoorFashionAccessories,
    'indoor-fast_food': IndoorFastFood,
    'indoor-fire_extinguisher': IndoorFireExtinguisher,
    'indoor-flight_ticket': IndoorFlightTicket,
    'indoor-florist': IndoorFlorist,
    'indoor-food_court': IndoorFoodCourt,
    'indoor-gate': IndoorGate,
    'indoor-gift': IndoorGift,
    'indoor-information': IndoorInformation,
    'indoor-interior_decoration': IndoorInteriorDecoration,
    'indoor-jewelry': IndoorJewelry,
    'indoor-kitchen': IndoorKitchen,
    'indoor-laboratory': IndoorLaboratory,
    'indoor-level': IndoorLevel,
    'indoor-lounge': IndoorLounge,
    'indoor-meeting': IndoorMeeting,
    'indoor-newsagent': IndoorNewsagent,
    'indoor-parking': IndoorParking,
    'indoor-pharmacy': IndoorPharmacy,
    'indoor-place_of_worship': IndoorPlaceOfWorship,
    'indoor-plane': IndoorPlane,
    'indoor-post_office': IndoorPostOffice,
    'indoor-rails': IndoorRails,
    'indoor-ramp': IndoorRamp,
    'indoor-reception_desk': IndoorReceptionDesk,
    'indoor-restaurant': IndoorRestaurant,
    'indoor-room': IndoorRoom,
    'indoor-security': IndoorSecurity,
    'indoor-server': IndoorServer,
    'indoor-shoes': IndoorShoes,
    'indoor-shop': IndoorShop,
    'indoor-shower': IndoorShower,
    'indoor-smoking_area': IndoorSmokingArea,
    'indoor-stairs': IndoorStairs,
    'indoor-storage': IndoorStorage,
    'indoor-supermarket': IndoorSupermarket,
    'indoor-taxi': IndoorTaxi,
    'indoor-technical': IndoorTechnical,
    'indoor-telephone': IndoorTelephone,
    'indoor-terrace': IndoorTerrace,
    'indoor-toilets': IndoorToilets,
    'indoor-train': IndoorTrain,
    'indoor-transports': IndoorTransports,
    'indoor-travel_agency': IndoorTravelAgency,
    'indoor-underwear': IndoorUnderwear,
    'indoor-venue': IndoorVenue,
    'indoor-waste_basket': IndoorWasteBasket,
    'indoor-workplace': IndoorWorkplace,
};

const MapDemo = {
    'map-route': MapRoute,
    'map-walk': MapWalk,
    'map-bike': MapBike,
    'map-train': MapTrain,
    'map-car': MapCar,
    'map-switch': MapSwitch,
    'map-itinerary': MapItinerary,
    'map-close': MapClose,
    'map-origin': MapOrigin,
    'map-pin': MapPin,
    'map-search': MapSearch,
    'map-arrow-top': MapArrowTop,
    'map-arrow-bottom': MapArrowBottom,
};

const ProductsIcons = {
    address: Address,
    connectors: Connectors,
    distance: Distance,
    geofencing: Geofencing,
    geolocation: Geolocation,
    indoor: Indoor,
    localities: Localities,
    mapping: Mapping,
    maps: Map,
    merchant: Merchant,
    multisearch: MultiSearch,
    storelocator: StoreLocator,
    stores: Stores,
    traffic: Traffic,
    showcases: Showcases,
};

const Icons = {
    ...WebsiteIcons,
    ...ConsoleIcons,
    ...ProductsIcons,
    ...MapDemo,
};

class Icon extends Component {
    render() {
        const { icon, size, className, isFill, isLoad, title, testId } = this.props;
        const IconComponent = Object.keys(Icons).includes(icon) ? Icons[icon] : Woosmap;
        const classes = cl('icon', { 'icon--fill': isFill }, { 'icon--load icon--fill': isLoad }, className);
        return (
            <IconComponent
                className={classes}
                data-testid={`${testId}-${icon}`}
                width={size}
                height={size}
                title={title}
            />
        );
    }
}

Icon.defaultProps = {
    size: 22,
    className: null,
    title: null,
    testId: 'icon',
    isFill: false,
    isLoad: false,
};

Icon.propTypes = {
    size: PropTypes.number,
    className: PropTypes.string,
    icon: PropTypes.string.isRequired,
    isFill: PropTypes.bool,
    isLoad: PropTypes.bool,
    title: PropTypes.string,
    testId: PropTypes.string,
};

export default Object.assign(Icon, {
    Icons,
    WebsiteIcons,
    ConsoleIcons,
    ProductsIcons,
    MapDemo,
});
